"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Switch = _interopRequireDefault(require("../../../components/Switch"));
var _Bubble = _interopRequireDefault(require("../../../components/Bubble"));
var _BubbleSelectBlock = _interopRequireDefault(require("../../../components/BubbleSelectBlock"));
var _NumberInput = _interopRequireDefault(require("../../../components/TextFields/NumberInput"));
var _Text = _interopRequireDefault(require("../../../components/Text"));
var _TextInput = _interopRequireDefault(require("../../../components/TextFields/TextInput"));
var _BlockContent = _interopRequireDefault(require("../../../components/BlockContent"));
var _HeaderDiv = _interopRequireDefault(require("../../../components/HeaderDiv"));
var _theme = require("../../../theme");
var _i18n = _interopRequireDefault(require("../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var LifeInsurance = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(LifeInsurance, _Component);
  function LifeInsurance() {
    var _this;
    (0, _classCallCheck2["default"])(this, LifeInsurance);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, LifeInsurance, [].concat(args)), _this.state = {
      data: null
    }, _this._setData = function (data) {
      // we want to set the early payment privilege to true for new plan designs, but false for existing plan designs
      // the earlyPaymentPrivilege field will be undefined for existing plan designs so we can check if the object is empty to
      // determine if the plan design is new

      var isEmpty = Object.keys(data).length === 0;
      var defaults = {
        isSelected: data.isSelected || false,
        isFlatAmount: data.isFlatAmount === undefined ? true : data.isFlatAmount,
        isTimesEarnings: data.isTimesEarnings || false,
        flatAmount: typeof data.flatAmount === "number" ? data.flatAmount : 0,
        timesEarnings: typeof data.timesEarnings === "number" ? data.timesEarnings : 1,
        maxNoEvidence: typeof data.maxNoEvidence === "number" ? data.maxNoEvidence : 0,
        maxEvidence: typeof data.maxEvidence === "number" ? data.maxEvidence : 0,
        reducesBy: typeof data.reducesBy === "number" ? data.reducesBy : 50,
        reducesAtAge: typeof data.reducesAtAge === "number" ? data.reducesAtAge : 70,
        furtherReducesBy: typeof data.reducesBy === "number" ? data.furtherReducesBy : 30,
        furtherReductionAge: typeof data.reducesAtAge === "number" ? data.furtherReductionAge : 85,
        includeSecondReduction: data.includeSecondReduction === undefined ? false : data.includeSecondReduction,
        earlyPaymentPrivilege: isEmpty ? true : Boolean(data.earlyPaymentPrivilege),
        terminationAge: typeof data.terminationAge === "number" ? data.terminationAge : 75,
        eligibilityPeriod: typeof data.eligibilityPeriod === "number" ? data.eligibilityPeriod : 3,
        minHoursPerWeek: typeof data.minHoursPerWeek === "number" ? data.minHoursPerWeek : 24,
        notes: data.notes || null
      };
      _this.setState({
        data: _objectSpread({}, defaults)
      });
      return defaults;
    }, _this._handleChange = function (field, value) {
      // we are viewing a revision so we don't need to set data in state
      if (_this.props.revision) {
        return;
      }
      _this.setState({
        data: _objectSpread(_objectSpread({}, _this.state.data), {}, (0, _defineProperty2["default"])({}, field, value))
      });
    }, _this._saveInGlobalState = function (field, value) {
      // we are viewing a revision so we don't need to set data in state
      if (_this.props.revision) {
        return;
      }
      if (field === 'notes' && value.toString().length === 0) {
        value = null;
      }
      if (_this.props.type === "modular") {
        _this.props.saveModularField(_this.props.classID, null, null, 'lifeInsurance', field, value);
      } else {
        _this.props.savePlanDesignField(_this.props.selectedClassID, _this.props.selectedDesignID, 'lifeInsurance', field, value);
      }
      _this.props.setChangesMadeFlag();
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _createClass2["default"])(LifeInsurance, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var defaults = this._setData(this.props.data);

      // we are viewing a revision so we don't need to set data in state
      if (this.props.revision) {
        return;
      }
      if (this.props.type === "modular") {
        // tier, tierBenefit, benefit, data

        // save the init data in global state so it's there for the save
        this.props.saveModularBenefitInitData(this.props.classID, null, null, 'lifeInsurance', defaults);
        return;
      }

      // save the init data in global state so it's there for the save
      this.props.savePlanDesignBenefitInitData(this.props.selectedClassID, this.props.selectedDesignID, 'lifeInsurance', defaults);
    }

    // eslint-disable-next-line camelcase
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var defaults = this._setData(nextProps.data);

      // we are viewing a revision so we don't need to set data in state
      if (this.props.revision) {
        return;
      }
      if (this.props.type === "modular") {
        return;
      }
      if (nextProps.selectedDesignID !== this.props.selectedDesignID) {
        // save the init data in global state so it's there for the save
        this.props.savePlanDesignBenefitInitData(this.props.selectedClassID, nextProps.selectedDesignID, 'lifeInsurance', defaults);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      if (!this.state.data) {
        return null;
      }
      var _this$props = this.props,
        errors = _this$props.errors,
        whitelabel = _this$props.whitelabel,
        isMasterSite = _this$props.isMasterSite,
        revision = _this$props.revision,
        isRevisionBlock = _this$props.isRevisionBlock;
      var data = this.state.data;
      var isSelected = Boolean(data.isSelected);
      return /*#__PURE__*/_react["default"].createElement(_BlockContent["default"], {
        style: isRevisionBlock ? {
          backgroundColor: '#F7F9FA'
        } : null
      }, /*#__PURE__*/_react["default"].createElement(_HeaderDiv["default"], {
        style: {
          borderBottom: isSelected ? "1.5px solid #F1F1F1" : null
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        large: true,
        bold: true,
        display: "block",
        margin: "20px 0",
        color: whitelabel.primaryColor || _theme.colors.skyBlue
      }, revision ? isRevisionBlock ? "".concat(_i18n["default"].t(_tokens["default"].titles.lifeInsurance), " (").concat(revision.revisionID, ")") : _i18n["default"].t(_tokens["default"].labels.planDesign.lifeInsuranceCurrent) : _i18n["default"].t(_tokens["default"].titles.lifeInsurance)), /*#__PURE__*/_react["default"].createElement(_Switch["default"], {
        checked: data.isSelected,
        onChange: function onChange() {
          return _this2._saveInGlobalState("isSelected", !isSelected);
        }
      })), isSelected && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          paddingTop: 20,
          paddingBottom: 50
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.selectBetween)), /*#__PURE__*/_react["default"].createElement(_BubbleSelectBlock["default"], {
        first: {
          title: _i18n["default"].t(_tokens["default"].labels.planDesign.flatAmount),
          selected: data.isFlatAmount,
          field: 'isFlatAmount'
        },
        second: {
          title: _i18n["default"].t(_tokens["default"].labels.planDesign.timesEarnings),
          selected: data.isTimesEarnings,
          field: 'isTimesEarnings'
        },
        handleChange: this._saveInGlobalState
      }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.completeFollowing)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, data.isFlatAmount && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.flatAmount),
        fullWidth: true,
        prefix: "$ ",
        value: data.flatAmount,
        onChange: function onChange(e) {
          return _this2._handleChange("flatAmount", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("flatAmount", e.target.value);
        },
        error: errors.flatAmount,
        variant: "outlined"
      })), data.isTimesEarnings && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.timesEarnings),
        fullWidth: true,
        value: data.timesEarnings,
        variant: "outlined",
        error: errors.timesEarnings,
        onChange: function onChange(e) {
          return _this2._handleChange("timesEarnings", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("timesEarnings", e.target.value);
        },
        select: true,
        selectOptions: [{
          key: 0,
          value: 1
        }, {
          key: 1,
          value: 1.5
        }, {
          key: 2,
          value: 2
        }, {
          key: 3,
          value: 2.5
        }, {
          key: 4,
          value: 3
        }]
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.nonEvidenceMaximum),
        fullWidth: true,
        prefix: "$ ",
        disabled: !isMasterSite,
        value: data.maxNoEvidence,
        onChange: function onChange(e) {
          return _this2._handleChange("maxNoEvidence", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("maxNoEvidence", e.target.value);
        },
        error: errors.maxNoEvidence,
        variant: "outlined"
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.maximumWithEvidence),
        fullWidth: true,
        prefix: "$ ",
        disabled: !isMasterSite,
        value: data.maxEvidence,
        onChange: function onChange(e) {
          return _this2._handleChange("maxEvidence", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("maxEvidence", e.target.value);
        },
        error: errors.maxEvidence,
        variant: "outlined"
      }))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.reducesBy),
        fullWidth: true,
        suffix: "%",
        value: data.reducesBy,
        onChange: function onChange(e) {
          return _this2._handleChange("reducesBy", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("reducesBy", e.target.value);
        },
        error: errors.reducesBy,
        variant: "outlined"
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.reducesAtAge),
        fullWidth: true,
        value: data.reducesAtAge,
        onChange: function onChange(e) {
          return _this2._handleChange("reducesAtAge", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("reducesAtAge", e.target.value);
        },
        error: errors.reducesAtAge,
        variant: "outlined"
      }))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.completeSecondReduction)), /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.secondReduction),
        isSelected: data.includeSecondReduction,
        onClick: function onClick() {
          return _this2._saveInGlobalState("includeSecondReduction", !data.includeSecondReduction);
        },
        customStyle: {
          marginBottom: "10px"
        }
      }), data.includeSecondReduction && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.secondReductionBy),
        fullWidth: true,
        suffix: "%",
        value: data.furtherReducesBy,
        onChange: function onChange(e) {
          return _this2._handleChange("furtherReducesBy", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("furtherReducesBy", e.target.value);
        },
        error: errors.furtherReducesBy,
        variant: "outlined"
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.secondReductionAtAge),
        fullWidth: true,
        value: data.furtherReductionAge,
        onChange: function onChange(e) {
          return _this2._handleChange("furtherReductionAge", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("furtherReductionAge", e.target.value);
        },
        error: errors.furtherReductionAge,
        variant: "outlined"
      }))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.earlyPaymentPrivilege),
        isSelected: Boolean(data.earlyPaymentPrivilege),
        onClick: function onClick() {
          return _this2._saveInGlobalState("earlyPaymentPrivilege", !data.earlyPaymentPrivilege);
        },
        customStyle: {
          marginBottom: "10px"
        }
      })), data.earlyPaymentPrivilege ? /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        value: _i18n["default"].t(_tokens["default"].labels.coverage.earlyPaymentPrivilegeDescription),
        disabled: true,
        customStyle: {
          width: "50%"
        },
        variant: "outlined"
      })) : null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        mediumLarge: true,
        bold: true,
        margin: "20px 0 10px 0"
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.planEligibilityTermination)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.completeFollowing)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.eligibilityPeriodMonths),
        fullWidth: true,
        value: data.eligibilityPeriod,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("eligibilityPeriod", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("eligibilityPeriod", e.target.value);
        },
        error: errors.eligibilityPeriod
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.minimumHoursPerWeek),
        fullWidth: true,
        value: data.minHoursPerWeek,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("minHoursPerWeek", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("minHoursPerWeek", e.target.value);
        },
        error: errors.minHoursPerWeek
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.terminationAge),
        fullWidth: true,
        value: data.terminationAge,
        onChange: function onChange(e) {
          return _this2._handleChange("terminationAge", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("terminationAge", e.target.value);
        },
        error: errors.terminationAge,
        variant: "outlined"
      }))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        bold: true
      }, "Notes:"), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        fullWidth: true,
        value: data.notes || '',
        variant: "outlined",
        error: errors.notes,
        onChange: function onChange(e) {
          return _this2._handleChange("notes", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("notes", e.target.value);
        },
        multiline: true,
        rows: 5,
        placeholder: _i18n["default"].t(_tokens["default"].labels.planDesign.additionalRequestsInformation)
      })));
    }
  }]);
  return LifeInsurance;
}(_react.Component);
var _default = exports["default"] = LifeInsurance;